"use client";

import React, { useState } from "react";
import { Box, Button, Grid2, Option, Select, Typography } from "@repo/ui";
import Section from "../components/Section";
import { useParams } from "next/navigation";
import { hasData } from "@/lib/helpers";
import { ArrowRight } from "lucide-react";
import LoadMore from "@/components/LoadMore";
import CourseCard2 from "@/components/courses/CourseCard2";
import Link from "next/link";

type CategorizedCoursesProps = {
  sectionInfo: PageSections;
  data: {
    categorizedCourses: CategorizedCoursesInterface[];
  };
};
const CategorizedCourses = (props: CategorizedCoursesProps) => {
  const { sectionInfo, data } = props;
  const { country } = useParams<{ country?: string }>();
  const [selectedCategory, setSelectedCategory] = useState(0);
  if (!hasData(data)) return null;
  return (
    <Section id={sectionInfo.sectionId} className={sectionInfo.sectionClass}>
      {/* Filter */}
      <Box flex className="justify-end">
        <Box>
          <Select
            noLabel
            value={selectedCategory}
            defaultValue={0}
            onChange={(value) => setSelectedCategory(value)}
            name="selectedCategory"
          >
            <Option value={0}>All Courses</Option>
            {data?.categorizedCourses.map((option) => (
              <Option
                value={parseInt(option.id)}
                key={`cat-option-${option.id}`}
              >
                {option.name}
              </Option>
            ))}
          </Select>
        </Box>
      </Box>
      {data?.categorizedCourses
        .filter(
          (item) =>
            parseInt(item.id) === selectedCategory || selectedCategory === 0
        )
        .map((cat) => (
          <Box key={cat.id} className="mt-6 mb-[3.75rem]">
            {/* Category name and action */}
            <Box className="mb-8 flex sm:flex-row flex-col sm:justify-between sm:items-center gap-4">
              <Typography variant="h4" render={<div />}>
                {`${cat.name} (${cat.totalCourse})`}
              </Typography>
              <Button
                roundedFull
                endIcon={<ArrowRight size={16} />}
                color="primary"
                variant="outlined"
                render={
                  <Link
                    href={
                      country
                        ? `/${country}/topic/${cat.slug}`
                        : `/topic/${cat.slug}`
                    }
                  />
                }
              >
                View all courses
              </Button>
            </Box>
            {/* Course Cards */}
            <LoadMore
              wrapper={<Grid2 container spacing={5} />}
              items={cat?.courses || []}
              initialVisibleItems={3}
              overlayHidden
              render={(item, index) => (
                <Grid2
                  key={`${item.slug}-${index}`}
                  size={{ xs: 12, sm: 12, md: 4, lg: 4 }}
                >
                  <CourseCard2
                    serviceId={item.id}
                    title={item.name}
                    coverSrc={item.service_image}
                    totalEnroll={item.numberOfLearners}
                    duration={item.serviceTrainingDays}
                    slug={item.slug}
                    accreditation_name={item.accreditation_name}
                    icon={item.serviceIcon}
                    modeOfTraining={
                      item.mode_of_training || "Live Classroom / Classroom"
                    }
                    sellingPriceNumber={item.price}
                    currency={item.currency}
                  />
                </Grid2>
              )}
            />
          </Box>
        ))}
    </Section>
  );
};

export default CategorizedCourses;
